import { CellProps } from 'react-table'
import { PlainHeader, StackedCell, StatusDot, TableColumn } from '../../../../../../components'
import { CategoriaNotificacaoLabels } from '../../../../../../../_metronic/helpers'
import { NotificacaoList } from '../../../core/_models'
import { NotificacaoActionsCell } from './NotificacaoActionsCell'

// O endpoint não ordena: cabeçalhos sem ordenação (como já era).
export const NotificacoesColumns: ReadonlyArray<TableColumn<NotificacaoList>> = [
  {
    Header: () => <PlainHeader>Notificação / Categoria</PlainHeader>,
    id: 'titulo',
    Cell: ({ row }: CellProps<NotificacaoList>) => (
      <StackedCell
        primary={row.original.titulo}
        secondary={
          row.original.categoria ? CategoriaNotificacaoLabels[row.original.categoria] : undefined
        }
      />
    ),
  },
  {
    Header: () => <PlainHeader>Situação</PlainHeader>,
    id: 'lida',
    cellWidth: '140px',
    // O texto carrega o significado; o ponto só reforça.
    Cell: ({ row }: CellProps<NotificacaoList>) =>
      row.original.lida ? (
        <StatusDot label='Lida' tone='success' />
      ) : (
        <StatusDot label='Não lida' tone='danger' />
      ),
  },
  {
    Header: () => <PlainHeader>Ações</PlainHeader>,
    id: 'actions',
    cellWidth: '132px',
    align: 'end',
    Cell: ({ row }: CellProps<NotificacaoList>) => (
      <NotificacaoActionsCell notificacao={row.original} />
    ),
  },
]
